
import ComChart from '@/components/charts/ComChart.vue'
import { defineComponent, reactive, toRefs, onMounted, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { EChartsOption } from 'echarts'
import { Dialog } from 'vant'
import { formatDate, getPreMonth, parseImgUrl, setQueryConfig } from '@/utils'
import {
  queryPortraitTempUserTotal,
  queryTotalIntegral,
  queryPortraitTempUserDetail,
  getSeasonBySeasonDate, queryTotalPortraitLight, queryPortraitLightUser
} from '@/apis/portrait'
import { store } from '@/store'

export default defineComponent({
  components: {
    [Dialog.Component.name]: Dialog.Component,
    ComChart
  },
  setup() {
    let options1: any = null
    let options2: any = null
    let route = useRoute()
    let id: any = route.query.type
    let energyData: any = {}
    let tempTotal: any = {}
    let comfortTextObj: any = {}
    let highComfortTemp: any = ''
    let lowComfortTemp: any = 0
    let adjustNum: any = ''
    let comfortType: any = ''
    let lightTotal: any = ''
    let router = useRouter()
    const proxyData = reactive({
      user: store.state.user,
      portait: store.state.portait,
      parseImgUrl: parseImgUrl,
      options1: options1,
      highComfortTemp: highComfortTemp,
      lowComfortTemp: lowComfortTemp,
      options2: options2,
      adjustNum: adjustNum,
      comfortType: comfortType,
      comfortTextObj: comfortTextObj,
      id: id,
      showNum: 0,
      seasonType: '',
      tempTotal: tempTotal,
      lightTotal: lightTotal,
      energyData: energyData,
      showDialog: false,
      /**
       * 节能分数
       */
      queryTotalIntegral() {
        let today = formatDate('')
        let lastMonth = getPreMonth()
        let params: any = {
          date: today,
          month: lastMonth
        }
        let query: string = setQueryConfig(params)
        queryTotalIntegral(query).then(function(res) {
          const resData: any = res
          if (res.result === 'success') {
            proxyData.energyData = resData
          }
          // console.log(proxyData.energyData)
        })
      },
      /**
       * 空调使用统计
       */
      queryPortraitTempUserTotal() {
        queryPortraitTempUserTotal().then(res => {
          const resData: any = res
          if (resData.result === 'success') {
            const data: any = resData?.data ?? {}
            proxyData.tempTotal = data
          }
        })
      },
      /**
       *  照明使用统计
       */
      queryTotalPortraitLight() {
        queryTotalPortraitLight().then(res => {
          const resData: any = res
          if (resData.result === 'success') {
            const data: any = resData?.data ?? {}
            proxyData.lightTotal = data
          }
        })
      },
      /**
       * 设置图表高亮颜色
       * @param chartList
       */
      setChartData(chartList: any) {
        let colorArr: any = []
        let data1: any = [0]
        let data2: any = [0]
        let temperatureArr: any = [0]
        chartList.map((item: any) => {
          if (item.type === 'up') {
            data1.push(item.num)
            temperatureArr.push(item.temperature)
          } else {
            data2.push(item.num)
          }
        })
        temperatureArr.map((item: any) => {
          if (item !== 0 && (item === proxyData.highComfortTemp || item === proxyData.lowComfortTemp)) {
            colorArr.push('#00DC23')
          } else {
            colorArr.push('transparent')
          }
        })
        return {
          colorArr: colorArr,
          temperatureArr: temperatureArr,
          data1: data1,
          data2: data2
        }
      },
      /**
       * 切换季节类型
       * @param type
       */
      triggerSeason(type: any) {
        proxyData.seasonType = type
        //  空调统计图表
        proxyData.queryPortraitTempUserDetail()
      },
      /**
       * 获取季节类型
       */
      getSeasonBySeasonDate() {
        let param: any = {
          projectId: proxyData.user.projectId,
          dateTime: formatDate('')
        }

        let paramStr: string = setQueryConfig(param)
        getSeasonBySeasonDate(paramStr).then(res => {
          let resData: any = res
          let type = (resData.content[0] || {}).type
          if (type == 1 || type == 3) {
            proxyData.seasonType = 'Cooling'
          } else {
            proxyData.seasonType = 'Warm'
          }
          //  空调统计
          proxyData.queryPortraitTempUserDetail()
        })
      },
      /**
       * 空调调节统计接口
       */
      queryPortraitTempUserDetail() {
        const param: any = {
          criteria: {
            'seasonType': proxyData.seasonType,
            'userId': proxyData.user.userId,
            'projectId': proxyData.user.projectId
          }
        }
        queryPortraitTempUserDetail(param).then(res => {
          const resData: any = res.data || {}
          const adjustDetails = resData.adjustDetails || []
          let adjustNum = 0
          let chartList: any = []
          // 标记处的值
          proxyData.highComfortTemp = resData.highComfortTemp ? resData.highComfortTemp : 0
          proxyData.lowComfortTemp = resData.lowComfortTemp ? resData.lowComfortTemp : 0
          proxyData.lowComfortTemp = (proxyData.lowComfortTemp == proxyData.highComfortTemp) ? 0 : proxyData.lowComfortTemp

          let comfortTemp: any = null

          if (proxyData.highComfortTemp && proxyData.lowComfortTemp) {
            comfortTemp = (proxyData.highComfortTemp + proxyData.lowComfortTemp) / 2
          } else if (proxyData.highComfortTemp && !proxyData.lowComfortTemp) {
            comfortTemp = proxyData.highComfortTemp
          } else if (!proxyData.highComfortTemp && proxyData.lowComfortTemp) {
            comfortTemp = lowComfortTemp
          }
          adjustDetails.forEach(function(item: any) {
            const baseData: any = [
              {
                temperature: item.temperature || 0,
                num: item.adjustUpNum,
                type: 'up'
              },
              {
                temperature: item.temperature || 0,
                num: -item.adjustDownNum,
                type: 'down'
              }]
            adjustNum = adjustNum + item.adjustUpNum + item.adjustDownNum
            chartList.push(...baseData)
          })
          // 设置图表的颜色
          let colorArr: any = proxyData.setChartData(chartList)
          proxyData.formateOptions1(colorArr)

          let comfortType = ''
          let comfortTextObj = {}
          if (adjustNum == 0) {
            proxyData.showNum = 0
            comfortType = 'zero'
            comfortTextObj = {
              firstLine: '温度关键词 无动于衷',
              img: parseImgUrl('page-portrait', 'zero.png')
            }
          } else if (adjustNum > 0 && !comfortTemp) {//不存在舒适温度
            proxyData.showNum = adjustNum
            comfortType = 'little'
            comfortTextObj = {
              firstLine: '温度关键词 随遇而安',
              img: parseImgUrl('page-portrait', 'littleBest.png')
            }

          } else {//获取舒适程度
            if (this.seasonType == 'Warm') {//冬天
              if (comfortTemp <= 18) {//说明耐冻
                comfortType = 'hardy'
                comfortTextObj = {
                  firstLine: '耐寒能力堪比 北极熊',
                  secondLine: '「落雪的日子，吃支雪糕去去火」',
                  img: parseImgUrl('page-portrait', 'bear.svg')
                }

              } else if (comfortTemp > 18 && comfortTemp < 24) {
                comfortType = 'good'
                comfortTextObj = {
                  firstLine: '温度适宜，享受当下',
                  secondLine: '「唯独工作可以带来快乐」',
                  img: parseImgUrl('page-portrait', 'duck.svg')
                }
              } else if (comfortTemp >= 24) {//说明耐热
                comfortType = 'heat'
                comfortTextObj = {
                  firstLine: '耐高温能力堪比双驼峰',
                  secondLine: '「阳光海滩，喝杯奶茶添点甜」',
                  img: parseImgUrl('page-portrait', 'camel.svg')
                }
              }
            } else {//夏天
              if (comfortTemp <= 23) {//说明耐冻
                comfortType = 'hardy'
                comfortTextObj = {
                  firstLine: '耐寒能力堪比 北极熊',
                  secondLine: '「落雪的日子，吃支雪糕去去火」',
                  img: parseImgUrl('page-portrait', 'bear.svg')
                  // img: this.h5StaticPath + '/page-portrait/bear.svg'
                }
              } else if (comfortTemp > 23 && comfortTemp < 27) {
                comfortType = 'good'
                comfortTextObj = {
                  firstLine: '温度适宜，享受当下',
                  secondLine: '「唯独工作可以带来快乐」',
                  img: parseImgUrl('page-portrait', 'duck.svg')
                }
              } else if (comfortTemp >= 27) {//说明耐热
                comfortType = 'heat'
                comfortTextObj = {
                  firstLine: '耐高温能力堪比双驼峰',
                  secondLine: '「阳光海滩，喝杯奶茶添点甜」',
                  img: parseImgUrl('page-portrait', 'camel.svg')
                }
              }
            }
          }
          proxyData.adjustNum = adjustNum
          proxyData.comfortType = comfortType
          proxyData.comfortTextObj = comfortTextObj
        })
      },
      /**
       * 照明统计echarts数据
       */
      queryPortraitLightUser() {
        const params = {
          criteria: {
            userId: proxyData.user.userId
          }
        }
        queryPortraitLightUser(params).then(res => {
          const resData: any = res
          const resList: any = resData.content || []
          let xData: any = []
          let data1: any = []
          let data2: any = []
          let data3: any = []
          resList.sort(function(a: any, b: any) {
            return a.hour - b.hour
          })
          resList.forEach(function(item: any, index: any) {
            item.hour = item.hour < 10 ? ('0' + item.hour + ':00') : (item.hour + ':00')
            xData.push(item.hour)
            data1.push(item.openNum)
            data2.push(item.closeNum)
            data3.push(item.closeOthersNum)
          })
          proxyData.formateOptions2(xData, data1, data2, data3)

        })
      },
      formateOptions1(chartArr: any) {
        let options1 = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            top: 10,
            align: 'left',
            left: 0,
            itemWidth: 15,
            itemHeight: 6,
            data: [
              {
                icon: 'roundRect',
                name: '调高'
              },
              {
                icon: 'roundRect',
                name: '调低'
              },
              {
                icon: 'roundRect',
                name: '舒适度'
              }
            ],
            textStyle: {
              fontSize: 12,
              color: '#C4C4C4'
            }
          },
          grid: {
            top: 50,
            left: 5,
            right: 10,
            bottom: 10,
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: 'rgba(196, 196, 196, 0.6)'
              }
            },
            axisLabel: {
              fontSize: 12,
              color: '#4D5262'
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: chartArr.colorArr
              }
            },
            data: chartArr.temperatureArr
          }],
          yAxis: [{
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(196, 196, 196, 0.6)'
              }
            },
            axisLabel: {
              fontSize: 12,
              color: '#4D5262'
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(196, 196, 196, 0.6)'
              }
            }
          }],
          series: [
            {
              name: '调高',
              smooth: true,
              symbol: 'circle',
              type: 'bar',
              stack: 'x',
              barWidth: 8,
              symbolSize: 5,
              showSymbol: false,
              itemStyle: {
                //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                normal: {
                  //柱形图圆角，初始化效果
                  barBorderRadius: [15, 15, 0, 0],
                  color: 'rgba(229, 87, 79, 1)'
                }
              },
              data: chartArr.data1
            },
            {
              name: '调低',
              smooth: true,
              symbol: 'circle',
              type: 'bar',
              stack: 'x',
              barWidth: 8,
              symbolSize: 5,
              showSymbol: false,
              itemStyle: {
                //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                normal: {
                  //柱形图圆角，初始化效果
                  barBorderRadius: [0, 0, 15, 15],
                  color: 'rgba(94, 139, 207, 1)'
                }
              },
              data: chartArr.data2
            },
            {
              name: '舒适度',
              smooth: true,
              symbol: 'circle',
              type: 'line',
              barWidth: 8,
              itemStyle: {
                normal: {
                  color: '#00DC23'
                }
              },
              symbolSize: 5,
              showSymbol: false,
              data: []
            }
          ]

        } as EChartsOption
        if (chartArr.temperatureArr && chartArr.temperatureArr.length) {
          proxyData.options1 = options1
        } else {
          proxyData.options1 = null
        }

      },
      /**
       *
       *  照明统计图
       * @param xData
       * @param data1 开灯
       * @param data2 关灯
       * @param data3  关闭其它的
       */
      formateOptions2(xData: any, data1: any, data2: any, data3: any) {
        let options2 = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            top: 0,
            align: 'left',
            left: 0,
            itemWidth: 15,
            itemHeight: 6,
            data: [
              {
                icon: 'roundRect',
                name: '开灯'
              },
              {
                icon: 'roundRect',
                name: '关灯'
              },
              {
                icon: 'roundRect',
                name: '关闭其他'
              }
            ],
            textStyle: {
              fontSize: 12,
              color: '#C4C4C4'
            }
          },
          grid: {
            top: 60,
            left: 10,
            right: 5,
            bottom: 10,
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            boundaryGap: true,
            axisLine: {
              lineStyle: {
                color: 'rgba(196, 196, 196, 0.6)'
              }
            },
            axisLabel: {
              fontSize: 12,
              color: '#4D5262'
            },
            data: xData
          }],
          yAxis: [{
            type: 'value',
            name: '单位（次）',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(196, 196, 196, 0.6)'
              }
            },
            axisLabel: {
              fontSize: 12,
              color: '#4D5262'
              // formatter:'{value}(次)'
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(196, 196, 196, 0.6)'
              }
            }
          }],
          series: [
            {
              name: '开灯',
              smooth: true,
              symbol: 'circle',
              type: 'bar',
              barWidth: 8,
              symbolSize: 5,
              showSymbol: false,
              itemStyle: {
                //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                normal: {
                  color: 'rgba(229, 87, 79, 1)'
                }
              },
              data: data1
            },
            {
              name: '关灯',
              smooth: true,
              symbol: 'circle',
              type: 'bar',
              barWidth: 6,
              symbolSize: 5,
              showSymbol: false,
              itemStyle: {
                //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                normal: {
                  color: 'rgba(94, 139, 207, 1)'
                }
              },
              data: data2
            },
            {
              name: '关闭其他',
              smooth: true,
              symbol: 'circle',
              type: 'bar',
              barWidth: 6,
              symbolSize: 5,
              showSymbol: false,
              itemStyle: {
                //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                normal: {
                  color: '#E89E32'
                }
              },
              data: data3
            }
          ]

        } as EChartsOption
        if (xData && xData.length) {
          proxyData.options2 = options2
        } else {
          proxyData.options2 = null
        }
      },
      /**
       * 节能详情&今日新增节能
       */
      goDeail(type: any = 'history') {
        if (type === 'today') {
          router.push({
            path: '/today-energy-detail',
            query: {
              totalPoints: proxyData.energyData.totalPoints,
              type: type
            }
          })
        } else {
          router.push({
            path: '/energy-detail',
            query: {
              totalPoints: proxyData.energyData.totalPoints,
              type: type
            }
          })
        }
      },
      /**
       * 排行榜
       */
      goRank() {
        router.push({ path: '/energy-rank' })
      },
      /**
       *
       * 调节记录
       */
      goRecord(type: any = '') {
        router.push({
          path: '/record',
          query: { type: type }
        })
      },
      /**
       *
       *空调节能详情
       */
      triggerDailog() {
        proxyData.showDialog = true
      }
    })
    nextTick(() => {
      if (proxyData.id && proxyData.id !== 'energy') {
        const document: any = window.document
        // console.log(document.getElementById(proxyData.id))
        let top = document.getElementById(proxyData.id).offsetTop - 20
        let pageEle = document.getElementById('page')
        pageEle.scrollTop = top
      }
    })
    onMounted(() => {
      // 节能评分
      proxyData.queryTotalIntegral()
      // 获取季节类型及温度统计图表
      proxyData.getSeasonBySeasonDate()
      // 空调使用统计
      proxyData.queryPortraitTempUserTotal()
      // 照明统计卡片
      proxyData.queryTotalPortraitLight()
      // 照明统计图表
      proxyData.queryPortraitLightUser()

    })
    return {
      ...toRefs(proxyData)
    }
  }
})
